export const headings = [
  { name: "Slot ID", width: 50 },
  { name: "Slot Name", width: 50 },
  { name: "Date", width: 50 },
  { name: "Timing", width: 50 },
  { name: "status", width: 50 },
  { name: "Hotel", width: 50 },
  { name: "Outlet", width: 50 },
  { name: "Attendance", width: 50 },
  { name: "action", width: 50 },
];

export const headingSlots = [
  { name: "Shift ID", width: 50 },
  { name: "Shift Name", width: 50 },
  { name: "Timing", width: 50 },
  { name: "Pay/Hr", width: 50 },
  { name: "Vacancies", width: 50 },
  { name: "Vacancies ", width: 50 },
  { name: "Groups", width: 50 },
  { name: "Exclusive", width: 50 },
  { name: "Subscribers", width: 50 },
  { name: "Remarks", width: 50 },
  { name: "Actions", width: 50 },
];

export const slotNameCreator = (date, hotelName, slotName) => {};
